export enum CountryCode {
    CANADIAN_COUNTRY_CODE = 'CA',
    UNITED_STATES_COUNTRY_CODE = 'US'
}
